import React from "react";
import "./OurApps.css";
import SLDLsinhala from "../../../assets/images/රියදුරු බලපත්‍ර විභාග පිළිතුරු.png";
import SLDLTamil from "../../../assets/images/Sri Lanka Driving Exam - தமிழ்.png";
import SLDLEnglish from "../../../assets/images/Sri Lankan Driving Exam Prep.png";
import SLDLIOS from "../../../assets/images/Mechsit-Sri lanka drivers exam.png";
import { Container, Row, Col } from "react-bootstrap";

function OurApps() {
  return (
    <Container fluid className="py-5  px-2 px-md-5 min-vh-80 articles-section">
      <div className="o-apps-section-container o-apps-section-vertical-space">
        <h2 className="mb-3 typography-title text-center text-md-center text-sm-center">
          Download - SLDL Apps
        </h2>
        <h3 className="mb-5  typography-paragraph  text-center text-md-center text-sm-center">
          Get the most out of our services! Download our other app for more
          features and benefits.
        </h3>
      </div>
      <Row className="d-flex justify-content-around  px-0 px-md-5">
        {/* Sinhala App */}
        <Col lg={3} md={3} sm={4} xs={6} className="text-center mb-4">
          <a
            href="https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl&hl=en"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div className="apps-click p-4 rounded-4 d-inline-block">
              <img
                src={SLDLsinhala}
                className="our-app-image"
                alt="රියදුරු බලපත්‍ර විභාග පිළිතුරු MechSIT SLDL Sinhala App"
                loading="lazy"
              />
              <p className="mt-2 typography-paragraph">SLDL Sinhala App</p>
            </div>
          </a>
        </Col>
        {/* Tamil App */}
        <Col lg={3} md={3} sm={4} xs={6} className="text-center mb-4">
          <a
            href="https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl.tm&hl=ta&pli=1"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {" "}
            <div className="apps-click p-4 rounded-4 d-inline-block">
              <img
                src={SLDLTamil}
                className="our-app-image"
                alt="MechSIT SLDL Tamil App - தமிழ்"
                loading="lazy"
              />
              <p className="mt-2 typography-paragraph">SLDL Tamil App</p>
            </div>
          </a>
        </Col>
        {/* English App */}
        <Col lg={3} md={3} sm={4} xs={6} className="text-center mb-4">
          <a
            href="https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl.en&hl=en"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {" "}
            <div className="apps-click p-4 rounded-4 d-inline-block">
              <img
                src={SLDLEnglish}
                className="our-app-image"
                alt="MechSIT SLDL English App"
                loading="lazy"
              />
              <p className="mt-2 typography-paragraph">SLDL English App</p>
            </div>
          </a>
        </Col>
        <Col lg={3} md={3} sm={4} xs={6} className="text-center mb-4">
          <a
            href="https://apps.apple.com/eg/app/mechsit-sri-lanka-drivers-exam/id1599318476"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {" "}
            <div className="apps-click p-4 rounded-4 d-inline-block">
              <img
                src={SLDLIOS}
                className="our-app-image"
                alt="MechSIT SLDL IOS App - Sri Lanka Driving Exam preparation App for IOS"
                loading="lazy"
              />
              <p className="mt-2 typography-paragraph">SLDL for IOS</p>
            </div>
          </a>
        </Col>
      </Row>
    </Container>
  );
}

export default OurApps;
